import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class PolicyConsentCypressAttributes extends CypressAttribute {
  static views = {
    POLICY_CONSENT_MODAL: 'PolicyConsentPlaywrightAttributes:POLICY_CONSENT_MODAL'
  };

  static inputs = {
    TERMS_OF_USE_CHECKBOX: 'PolicyConsentPlaywrightAttributes:TERMS_OF_USE_CHECKBOX',
    PRIVACY_POLICY_CHECKBOX: 'PolicyConsentPlaywrightAttributes:PRIVACY_POLICY_CHECKBOX',
    SHOW_TERM_OF_USE_MODAL: 'PolicyConsentPlaywrightAttributes:SHOW_TERM_OF_USE_MODAL',
    SHOW_PRIVACY_POLICY_MODAL: 'PolicyConsentPlaywrightAttributes:SHOW_PRIVACY_POLICY_MODAL'
  };
}
